import {
  ExlyDatePicker,
  ExlyDropdown,
  ExlyInput,
  ExlyTextarea,
  ExlyTimePicker,
} from "common/form";
import { COLUMN_FIELD_TYPE_OPTIONS } from "../../../constants/CustomColumnFormField.constants";
import ExlyComplexDropdown from "common/form/ExlyComplexDropdown";
import { GENDERS } from "ui/pages/marketing/Ads/Utils";
import { indian_states_and_uts_dropdown_options } from "features/Common/constants/indianState";
import { indian_cities_dropdown_options } from "features/Common/constants/indianCity";

const generateOptions = ({ options }) => {
  return options
    ?.filter(({ option = "" } = {}) => option !== "")
    .map(({ option }) => ({
      label: option,
      value: option,
    }));
};
export const generateInputDefaultValuesProps = ({
  type,
  options = [],
  orgMembers,
}) => {
  const requireOptions = [
    COLUMN_FIELD_TYPE_OPTIONS.single_select.value,
    COLUMN_FIELD_TYPE_OPTIONS.multiple_select.value,
    COLUMN_FIELD_TYPE_OPTIONS.assignee.value,
    COLUMN_FIELD_TYPE_OPTIONS.indian_city.value,
    COLUMN_FIELD_TYPE_OPTIONS.indian_state.value,
    COLUMN_FIELD_TYPE_OPTIONS.gender.value,
  ].includes(type);

  const creatorOptionsUndefined = options.every((item) => item === undefined);

  switch (type) {
    case COLUMN_FIELD_TYPE_OPTIONS.short_text.value:
      return {
        placeholder: "Enter default text...",
        component: ExlyInput,
      };
    case COLUMN_FIELD_TYPE_OPTIONS.url.value:
      return {
        placeholder: "Paste URL",
        component: ExlyInput,
      };
    case COLUMN_FIELD_TYPE_OPTIONS.paragraph_text.value:
      return {
        placeholder: "Enter default text...",
        minHeight: "72px",
        component: ExlyTextarea,
      };
    case COLUMN_FIELD_TYPE_OPTIONS.single_select.value: {
      const dropdownOptions = generateOptions({ options });
      return {
        placeholder: "Select option",
        component: ExlyDropdown,
        disabled: requireOptions && creatorOptionsUndefined,
        options: dropdownOptions,
      };
    }
    case COLUMN_FIELD_TYPE_OPTIONS.assignee.value:
      return {
        placeholder: "Select member",
        component: ExlyDropdown,
        options: orgMembers,
      };
    case COLUMN_FIELD_TYPE_OPTIONS.indian_city.value:
      return {
        placeholder: "Select city",
        component: ExlyDropdown,
        options: indian_cities_dropdown_options,
      };
    case COLUMN_FIELD_TYPE_OPTIONS.indian_state.value:
      return {
        placeholder: "Select state",
        component: ExlyDropdown,
        options: indian_states_and_uts_dropdown_options,
      };
    case COLUMN_FIELD_TYPE_OPTIONS.gender.value:
      return {
        placeholder: "Select option",
        component: ExlyDropdown,
        options: Object.values(GENDERS),
      };
    case COLUMN_FIELD_TYPE_OPTIONS.multiple_select.value: {
      const dropdownOptions = generateOptions({ options });
      return {
        placeholder: "Select option",
        component: ExlyComplexDropdown,
        disabled: requireOptions && creatorOptionsUndefined,
        options: dropdownOptions,
        multiple: true,
      };
    }
    case COLUMN_FIELD_TYPE_OPTIONS.date.value:
      return {
        placeholder: "Choose date",
        component: ExlyDatePicker,
      };
    case COLUMN_FIELD_TYPE_OPTIONS.time.value:
      return {
        placeholder: "Choose time",
        component: ExlyTimePicker,
      };
    default:
      return {
        component: ExlyInput,
      };
  }
};
